export const userKeys = {
  user: id => ["user", id],
};
